module.exports = __webpack_public_path__ + "img/Klipsu-II.58e7214b.png";